var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddbenefit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64 9A55 55 0 1 0 64 119A55 55 0 1 0 64 9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#444b54",
    d: "M64,122C32,122,6,96,6,64S32,6,64,6s58,26,58,58c0,1.7-1.3,3-3,3s-3-1.3-3-3c0-28.7-23.3-52-52-52S12,35.3,12,64s23.3,52,52,52c1.7,0,3,1.3,3,3S65.7,122,64,122z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1fd4af",
    d: "M102 82A20 20 0 1 0 102 122A20 20 0 1 0 102 82Z",
    transform: "rotate(-45.001 102 102.002)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M109,99h-4v-4c0-1.7-1.3-3-3-3s-3,1.3-3,3v4h-4c-1.7,0-3,1.3-3,3s1.3,3,3,3h4v4c0,1.7,1.3,3,3,3s3-1.3,3-3v-4h4c1.7,0,3-1.3,3-3S110.7,99,109,99z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#444b54",
    d: "M75.1,73.9c0-3.7-1.8-7.1-4.8-9.2L61,58.3c-1.3-1-2.1-2.5-2.1-4.2c0-2.8,2.3-5.1,5.1-5.1c2.1,0,3.9,1.2,4.7,3.1c0.6,1.5,2.4,2.2,3.9,1.6c1.5-0.6,2.2-2.4,1.6-3.9c-1.3-3.2-4-5.5-7.2-6.4V43c0-1.7-1.3-3-3-3s-3,1.3-3,3v0.4c-4.7,1.3-8.1,5.6-8.1,10.7c0,3.6,1.7,6.9,4.7,9l9.3,6.5c1.4,1,2.2,2.5,2.2,4.2c0,2.8-2.3,5.1-5.1,5.1c-2,0-3.9-1.2-4.7-3.1c-0.7-1.5-2.4-2.2-3.9-1.6c-1.5,0.7-2.2,2.4-1.6,3.9c1.4,3.1,4,5.4,7.2,6.3V85c0,1.7,1.3,3,3,3s3-1.3,3-3v-0.4C71.7,83.3,75.1,79,75.1,73.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddbenefit);
export default __webpack_public_path__ + "static/media/addbenefit.c7020df1079a7be8970d2131c62996e5.svg";
export { ForwardRef as ReactComponent };